<div   style="width: 100%; background-color: white">
    <div class="button-stepper-footer">
      
      <button   (click)="openDeactivateModal()"    mat-stroked-button
      mat-button class="button-stepper-deactivae"
    >
    DEACTIVATE PROPERTY <mat-icon >pause_circle</mat-icon>
      </button>

      <button    mat-stroked-button
      mat-button class="button-stepper-allow"
    >
    SAVE <mat-icon >save</mat-icon>
      </button>
    </div>
  </div>